import App from './App.vue';
import type { LoaderFn, CreateAppFn } from '$app/config';
import { createSSRApp, createApp as createVueApp, App as VueApp } from 'vue';
import { LICENSES_PATHS } from './utils/constants';
import { fetchUrl } from './utils/util';
import { Tenant, Component } from './types';

const createApp: CreateAppFn<any, any> = async (renderMode, componentId, data) => {
  let app: VueApp<Element>;
  if (import.meta.env.SSR || renderMode !== 'csr') {
    app = createSSRApp(App, { componentId, data });
  } else {
    console.log('CREATE APP', renderMode, componentId, data);
    // fallback to CSR (the loaderDataFn might be required to mimic SSR behaviour if it exists)
    app = createVueApp(App, { componentId, data });
  }

  return app;
};

const loader: LoaderFn<any, any> = async (context: any) => {
  const assetUrl = context.globalAEMContext.assetUri;
  const licensesResponse = await fetchUrl(`${assetUrl}/${LICENSES_PATHS.tenantId}/${LICENSES_PATHS.manifest}`);

  // filter out tenants that are empty
  licensesResponse.tenants = licensesResponse.tenants
    .map((tenant: Tenant) => ({
      ...tenant,
      components: tenant.components.filter((component: Component) => component.dependencies > 0),
    }))
    .filter((tenant: Tenant) => tenant.components.length > 0);

  return {
    ...context,
    licenses: licensesResponse,
  };
};

export default {
  createApp,
  loader,
};
